export enum checkStatus {
  save = 0,
  submit = 1,
  rejected = -1,
  success = 2
}
export enum ConverStatus {
  unStart,
  inProgress,
  success,
  fail
}

export interface TaskFile {
  taskFile: {
    uploadFileId: string;
    taskId: string;
    isTaskRule: false;
    taskRuleId: string;
    creationTime: string;
    createUserId: string;
    id: string;
  };
  uploadFile: {
    fileId: string;
    fileName: string;
    fileExtention: string;
    fileTaskId: string;
    fileConvertState: number;
    fileHash: string;
    fileSize: string | number;
    fileUrl: string;
    modelGroupId: string;
    type: number[];
    isLocked: boolean;
    creationTime: string | Date;
    createUserId: number | string;
    id: number | string;
  };
}
export interface UploadFile {
  fileId: string;
  fileName: string;
  fileExtention: string;
  fileTaskId: string;
  fileConvertState: number;
  fileHash: string;
  fileSize: number;
  fileUrl: string;
  modelGroupId: string;
  type: number;
  isLocked: true;
  creationTime: string;
  createUserId: string;
  id: string;
}
